/**
 * @fileoverview Display helpers for a pre-join visitor's location and device.
 */

import type { PrejoinVisitor } from './prejoin-live.models';

/** "Delhi, National Capital Territory of Delhi, India" (skipping blanks), or "—". */
export function visitorPlace(v: PrejoinVisitor | null | undefined): string {
  const parts = [v?.city, v?.region, v?.country].filter((p): p is string => !!p);
  return parts.length ? [...new Set(parts)].join(', ') : '—';
}

/** "Chrome · Windows · desktop" (skipping blanks), or "—". */
export function visitorDevice(v: PrejoinVisitor | null | undefined): string {
  const parts = [v?.browser, v?.os, v?.deviceType].filter((p): p is string => !!p);
  return parts.length ? parts.join(' · ') : '—';
}
